import classNames from 'classnames'

import { getQaSelector } from '../../../utils/common'
import { DragDropProvider } from '../../DragDrop'

import {
  QA_NAME_REQUEST_BOARD,
  REQUEST_BOARD_KEYBOARD_CODES,
} from './RequestBoard.constants'
import {
  getRequestBoardCollisions,
  getRequestBoardKeyboardCoordinates,
  isRequestBoardColumnDropDisabled,
  isRequestBoardOverDroppable,
} from './RequestBoard.utils'
import { RequestBoardCard } from './RequestBoardCard'
import { RequestBoardColumn } from './RequestBoardColumn'

import * as styles from './RequestBoard.module.css'

function RequestBoard({
  cardProps,
  columns,
  draggedStatus,
  dropStatus,
  pendingIds,
  onDragCancel,
  onDragEnd,
  onDragOver,
  onDragStart,
}) {
  function renderDraggedCard(activeId, activeData) {
    return activeData?.item ? (
      <RequestBoardCard {...cardProps} item={activeData.item} />
    ) : null
  }

  return (
    <DragDropProvider
      {...getQaSelector({ value: QA_NAME_REQUEST_BOARD })}
      className={styles.RequestBoard}
      collisionDetection={getRequestBoardCollisions}
      dndContextProps={{ autoScroll: false }}
      keyboardCodes={REQUEST_BOARD_KEYBOARD_CODES}
      keyboardCoordinateGetter={getRequestBoardKeyboardCoordinates}
      overlayProps={{
        className: classNames(styles.overlay, {
          [styles.noDrop]: !isRequestBoardOverDroppable(dropStatus),
        }),
      }}
      renderOverlay={renderDraggedCard}
      onDragCancel={onDragCancel}
      onDragEnd={onDragEnd}
      onDragOver={onDragOver}
      onDragStart={onDragStart}
    >
      <div className={styles.columns}>
        {columns.map(column => (
          <RequestBoardColumn
            cardProps={cardProps}
            column={column}
            isDropDisabled={isRequestBoardColumnDropDisabled({
              column,
              draggedStatus,
            })}
            key={column.status}
            pendingIds={pendingIds}
          />
        ))}
      </div>
    </DragDropProvider>
  )
}

export default RequestBoard
